"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = _interopRequireDefault(require("../../theme"));
var _excluded = ["size", "color", "fillColor", "accessibleTitle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @deprecated Use <Icon icon="info" /> instead
 */
var AlertInformation = function AlertInformation(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 25 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "".concat(_theme["default"].indigo120) : _ref$color,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? '#e2e2e2' : _ref$fillColor,
    _ref$accessibleTitle = _ref.accessibleTitle,
    accessibleTitle = _ref$accessibleTitle === void 0 ? 'Information' : _ref$accessibleTitle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size
    }
  }, otherProps, {
    viewBox: "0 0 28 28"
  }), /*#__PURE__*/_react["default"].createElement("title", null, accessibleTitle), /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM14 26.25C7.23451 26.25 1.75 20.7655 1.75 14C1.75 7.23451 7.23451 1.75 14 1.75C20.7655 1.75 26.25 7.23451 26.25 14C26.25 20.7655 20.7655 26.25 14 26.25ZM13.9741 10.2667C13.1394 10.2667 12.583 9.64422 12.6004 8.87582C12.583 8.0703 13.1394 7.46667 13.991 7.46667C14.8431 7.46667 15.3821 8.07081 15.4 8.87582C15.3995 9.64422 14.8436 10.2667 13.9741 10.2667ZM15.4 18.9778C15.4 19.837 14.7733 20.5333 14 20.5333C13.2267 20.5333 12.6 19.837 12.6 18.9778V12.7556C12.6 11.8964 13.2267 11.2 14 11.2C14.7733 11.2 15.4 11.8964 15.4 12.7556V18.9778Z"
  }));
};
AlertInformation.propTypes = {
  size: _propTypes["default"].number,
  color: _propTypes["default"].string,
  fillColor: _propTypes["default"].string,
  accessibleTitle: _propTypes["default"].string
};
var _default = exports["default"] = AlertInformation;